import React, { useState, useEffect } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Scrollbar, A11y } from 'swiper';
import { CommonApiFun } from '../../Redux/Action/index'
import { useDispatch } from 'react-redux'
import imgPlaceHolder from '../../img/evnetPlaceHolder.png';
import { toast } from 'react-toastify';
import moment from 'moment'
function Payment(props) {
    const { activeTab } = props.data
    const [isloading, setIsloading] = useState(false)
    const [orderRes, setOrderRes] = useState({})
    var transaction_id = orderRes.orderRes
    const { FirstName, LastName, MobileNo, Emial, Address, day, time, Gender, BirthDate, res, Endtime, razorpay_payment_id, userImage, paymentRes } = props.data
    const dispatch = useDispatch()
    useEffect(() => {
        const script = document.createElement('script');
        script.src = 'https://checkout.razorpay.com/v1/checkout.js';
        script.async = true;
        document.body.appendChild(script);
        return () => {
            document.body.removeChild(script);
        }
    }, []);
    const submitData = (e) => {
        e.preventDefault()
        setIsloading(true)
        var data = {
            patient_id: res.patient_key,
            order_amount: res.data.new_patient_appoinment_fee,
            appointment_id: paymentRes == "" ? "" : paymentRes.appointmentKey,
        }
        
        dispatch(CommonApiFun("api/payment/post", JSON.stringify(data))).then(async (res) => {

            
            if (res.status == "success") {
                await setOrderRes(res)
                // props.handleState("paymentRes", res)
                onsubmit(res)
                //toast.success(res.message)
            } else {
                setIsloading(false)
                toast.error(res.message)
            }

        }).catch((e) => {})
        
    }

    const onsubmit = (result) => {
     
        const { key, amount, order_id, currency } = result.data;

        const options = {
            key: key,
            currency: "INR",
            amount: amount, //  = INR 1
            name: 'Ansh clinic',
            description: 'some description',
            image: imgPlaceHolder,
            order_id: order_id,
            modal: {
                "ondismiss": function () {
                    setIsloading(false)
                }
            },
            handler: function (response) {
                response.pid = res.patient_key
                response.tid = result.transaction_id
                response.aid = result.appointment_id
              
                dispatch(CommonApiFun('api/payment_approve/post', JSON.stringify(response))).then(async (res) => {
                    setIsloading(false)
                    props.handleNext()

                }).catch((e) => {  })
            },
            prefill: {
                name: FirstName + " " + LastName,
                contact: '91'+MobileNo,
                email: Emial,
              
            },
            notes: {
                address: Address
            },
            // callback_url: 'http://192.169.143.211/~devapp/ansh_clinic/admin/api/payment_approve/post?pid=' + res.patient_key + '&tid=' + result.transaction_id + '&aid=' + result.appointment_id,
            // redirect: true
        };
   

        var rzp1 = new window.Razorpay(options);
        rzp1.open();

    }
    return (
        <>

            <div className={`main ${activeTab == 3 ? "active" : ''}`} style={{ position: 'relative' }}>
                {isloading && <div className='payment-loader'><span></span></div>}
                <div style={{ opacity: isloading ? 0.5 : 1 }}>
                    <div className="text">
                        <h3>Payment</h3>
                        <p>Can you talk about your past work experience?</p>
                    </div>
                    <div className="main-content">

                        <div className="patient_info">
                            <div className="info_box">
                                <span className="info_box_img">
                                    <img
                                        className="img-circle"
                                        src={userImage == "" ? require('../../img/evnetPlaceHolder.png') : userImage}
                                        alt="User Image"
                                    />
                                </span>
                            </div>
                            <div className="info_box">
                                <b>Patient Name</b>
                                <span>{FirstName} {LastName}</span>
                            </div>
                            <div className="info_box">
                                <b>Patient Gender</b>
                                <span>{Gender}</span>
                            </div>
                            <div className="info_box">
                                <b>Patient Birthdate</b>
                                <span>{BirthDate}</span>
                            </div>
                          
                            <div className="info_box">
                                <b>Visiting Date</b>
                                <span>{moment(day).format('YYYY-MM-DD')}</span>
                            </div>
                            <div className="info_box">
                                <b>Visiting Time</b>
                                <span>{moment(time, "hh:mm").format('LT')}</span>
                            </div>
                            <div className="info_box">
                                <b>Address</b>
                                <span>
                                    {Address}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="buttons button_space">
                        {" "}
                        <button className="btn back_button btn-relative" onClick={() => props.handlePrev()}>Back</button>{" "}
                        <button className={`btn next_button btn-relative`}
                            onClick={(e) => Object.keys(orderRes).length != 0 ? onsubmit(orderRes) : submitData(e)}
                        >
                            <span className="btn-text">Payment</span>
                            <span className="btn__loader">
                                <div
                                    role="progressbar"
                                    aria-valuemin={0}
                                    aria-valuemax={100}
                                    className="progress-circular progress-circular--visible progress-circular--indet"
                                    style={{ height: 23, width: 23 }}
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="21.904761904761905 21.904761904761905 43.80952380952381 43.80952380952381"
                                        style={{ transform: "rotate(0deg)" }}
                                    >
                                        <circle
                                            fill="transparent"
                                            cx="43.80952380952381"
                                            cy="43.80952380952381"
                                            r={20}
                                            strokeWidth="3.8095238095238093"
                                            strokeDasharray="125.664"
                                            strokeDashoffset="125.66370614359172px"
                                            className="progress-circular__overlay"
                                        />
                                    </svg>
                                </div>
                            </span>
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Payment;